export enum ShiftSystem {
  ThreeShifts = 'three_shifts',
  TwoShifts = 'two_shifts',
  NightWatch = 'night_watch',
  EarlyShift = 'early_shift',
  LateShift = 'late_shift',
  NightShift = 'night_shift',
  ParentShift = 'parent_shift',
  TwelveHoursDayShift = '12_hours_day_shift',
  TwelveHoursNightShift = '12_hours_night_shift',
}

export const SHIFT_SYSTEM_I18N = {
  [ShiftSystem.EarlyShift]: 'Frühschicht',
  [ShiftSystem.LateShift]: 'Spätschicht',
  [ShiftSystem.NightShift]: 'Nachtschicht',
  [ShiftSystem.NightWatch]: 'Dauernachtwache',
  [ShiftSystem.ParentShift]: 'Elterndienst',
  [ShiftSystem.ThreeShifts]: '3-Schichtsystem',
  [ShiftSystem.TwoShifts]: '2-Schichtsystem (ohne Nächte)',
  [ShiftSystem.TwelveHoursDayShift]: '12-Stunden-Schichten (Tagdienst)',
  [ShiftSystem.TwelveHoursNightShift]: '12-Stunden-Schichten (Nachtdienst)',
};
